import { Checkbox, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem,  Select, TextField, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import React from 'react'
import { useTranslation } from 'react-i18next'

const QuestionnaireTemplateModal = ({ value, handleChange, errors, clearError, activeCheckboxState, setActiveCheckboxState }) => {
    const { t } = useTranslation()
    return (
        <>
            <Typography
                variant="h6"
                sx={{
                    px: 2,
                    py: 1.5
                }}>
                {t('general.template')}
            </Typography>
            <Divider sx={{
                my: 0
            }} />
            <Grid container sx={{
                py: 1
            }} spacing={{ xs: 2, md: 0 }}>
                <Grid size={{ xs: 12, md: 4 }} sx={{ borderRight: { xs: "none", sm: `1px dashed ${grey[200]}` } }}>
                    <Grid container spacing={1} sx={{ px: 2 }}>
                        <Grid size={{ xs: 12 }}>
                            <Typography variant='body1'>{t('general.general')}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12 }} pb={1}>
                            <Divider />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={t('general.template')}
                                        value={value?.name}
                                        autoComplete='off'
                                        size='small'
                                        fullWidth
                                        error={errors?.name}
                                        helperText={errors?.name}
                                        onChange={(e) => {
                                            handleChange({ keyName: "name", value: e.target.value })
                                            clearError("name")
                                        }} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={t('general.description')}
                                        value={value?.description}
                                        autoComplete='off'
                                        size='small'
                                        fullWidth
                                        error={errors?.description}
                                        helperText={errors?.description}
                                        onChange={(e) => {
                                            handleChange({ keyName: "description", value: e.target.value })
                                            clearError("description")
                                        }} />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <TextField
                                        disabled
                                        id="outlined-multiline-flexible"
                                        label={t('general.version')}
                                        value={value?.version}
                                        size='small'
                                        fullWidth
                                    />
                                </Grid>
                                 <Grid size={{ xs: 12 }}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={t('questionnaire.reportHeader')}
                                        value={value?.reportHeader}
                                        autoComplete='off'
                                        size='small'
                                        fullWidth
                                        error={!!errors?.reportHeader}
                                        helperText={errors?.reportHeader}
                                        onChange={(e) => {
                                            handleChange({ keyName: "reportHeader", value: e.target.value })
                                            clearError("reportHeader")
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={activeCheckboxState.isChecked}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setActiveCheckboxState({ ...activeCheckboxState, isChecked: checked });
                                                        handleChange({ keyName: "active", value: checked });
                                                    }}
                                                />
                                            }
                                            label={t("general.active")}
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default QuestionnaireTemplateModal
